import { connect } from 'react-redux';
import { ResourceTable } from '../components/index';

function getLocationValue(location) {
  if (location === 'On Campus') return 0;
  if (location === 'Online') return 1;
  return 2;
}

const sortResources = (resources, sortBy) => {
  if (!resources) return [];
  const sorted = [...resources];
  if (sortBy === 'views') {
    return sorted.sort((a, b) => {
      if (a.p[0][0] < b.p[0][0]) return -1;
      if (a.p[0][0] > b.p[0][0]) return 1;
      return 0;
    });
  } else if (sortBy === 'location') {
    return sorted.sort((a, b) => {
      if (getLocationValue(a.onCampus) < getLocationValue(b.onCampus)) return -1;
      if (getLocationValue(a.onCampus) > getLocationValue(b.onCampus)) return 1;
      return 0;
    });
  } else if (sortBy === 'alphaUp') {
    return sorted.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
  } else if (sortBy === 'alphaDown') {
    return sorted.sort((a, b) => {
      if (a.name > b.name) return -1;
      if (a.name < b.name) return 1;
      return 0;
    });
  }
  return sorted;
};

const mapStateToProps = state => ({
  resources: sortResources(state.results, state.sortBy),
  resourceEditorOpen: state.resourceEditor.open,
});

const FilteredResourceTable = connect(
  mapStateToProps,
)(ResourceTable);

export default FilteredResourceTable;



// WEBPACK FOOTER //
// ./src/containers/FilteredResourceTable.js